import React from "react";
import { SOLUTIONS_SCRUTINY_CARDS } from "./solutionsData";

export default function SolutionsScrutiny() {
  return (
    <section className="sol-scrutiny">
      <div className="sol-scrutiny__header">
        <h2>
          Built for scrutiny, not just
          <br />
          speed
        </h2>
        <p>Specifics, not badges — this is exactly what's enforced under the hood.</p>
      </div>
      <div className="sol-scrutiny__grid">
        {SOLUTIONS_SCRUTINY_CARDS.map((card) => (
          <article key={card.title} className="sol-scrutiny__card">
            <h3>{card.title}</h3>
            <p>
              {card.bodyParts.map((part, index) =>
                typeof part === "string" ? (
                  part
                ) : (
                  <strong key={`${card.title}-${index}`}>{part.strong}</strong>
                )
              )}
            </p>
          </article>
        ))}
      </div>
    </section>
  );
}
